export const freeGiftTrack = (active, gifts) => ({
  active,
  gifts: gifts?.sort((a, b) => a.threshold - b.threshold),

  get maxThreshold() {
    return Math.max(...this.gifts.map((gift) => gift.threshold));
  },

  get progress() {
    const cartTotal = Alpine.store("cart").totalPrice / 100;
    const giftFirst = this.gifts[0];
    const toFixed = (amount) => amount?.toFixed(2);

    if (cartTotal < giftFirst?.threshold) {
      return {
        percentage: (cartTotal / giftFirst.threshold) * 50 + "%",
        nextItem: giftFirst.name,
        remainder: toFixed(giftFirst.threshold - cartTotal),
      };
    } else {
      // Calculate based on if total Price is less than all Items is less than maxThreshold
      const giftsLength = this.gifts.length;

      for (let i = 0; i < giftsLength; i++) {
        const giftCurrent = this.gifts[i];
        const giftPrev = this.gifts[i - 1];

        if (cartTotal < giftCurrent?.threshold) {
          const interval = 50 / (giftsLength - 1);
          const intervalPrev = 50 + (i - 1) * interval;
          const boundsLower = giftPrev?.threshold || this.gifts[0].threshold;
          const boundsUpper = giftCurrent.threshold;
          const boundsRange = boundsUpper - boundsLower;
          const boundsPercentage = (cartTotal - boundsLower) / boundsRange;
          const percentage = intervalPrev + interval * boundsPercentage;

          return {
            percentage: toFixed(percentage) + "%",
            nextItem:
              giftCurrent?.name.toLowerCase() === "shipping"
                ? "Free " + giftCurrent?.name
                : giftCurrent?.name,
            remainder: toFixed(giftCurrent?.threshold - cartTotal),
          };
        }
      }
    }

    return {
      percentage: "100%",
      nextItem: null,
      remainder: 0,
    };
  },

  // Sort divs inside the outer according to threshold
  init() {
    const outer = this.$refs.outer;
    const items = Array.from(outer.children).map((item) => ({
      el: item,
      threshold: Number(item.getAttribute("data-threshold")),
    }));

    items.sort((a, b) => a.threshold - b.threshold);

    // Remove all items from the parent
    while (outer.firstChild) {
      outer.removeChild(outer.firstChild);
    }

    // Append sorted items back to the parent
    items.forEach((item) => {
      outer.appendChild(item.el);
    });
  },
});
